'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.proGalleryItemsToWixCode = exports.proGalleryItemToWixCode = exports.wixCodeItemsToProGallery = exports.wixCodeItemToProGallery = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _utils = require('./utils');

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formatTextLinkToObject = function formatTextLinkToObject(link, target) {
  switch (typeof link === 'undefined' ? 'undefined' : (0, _typeof3.default)(link)) {
    case 'object':
      return {
        type: 'wix',
        data: link
      };
    case 'string':
      return {
        type: 'web',
        url: link,
        target: target
      };
    default:
      return {
        target: '_blank',
        type: 'none'
      };
  }
};

var formatObjectLinkToText = function formatObjectLinkToText() {
  var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  //todo - update defs from here: https://www.wix.com/code/reference/$w.LinkableMixin.html#link
  var _link = {
    link: link.url
  };
  if (link.url) {
    _link.target = link.target;
  }
  return _link;
};

var isMediaSrc = function isMediaSrc(src) {
  var regex = /^(wix:)?(image|video)(:\/\/)/;
  return regex.exec(src) !== null;
};

var formatSrcToMediaUrl = function formatSrcToMediaUrl(src) {
  return isMediaSrc(src) ? src.split('/')[3] : src; //convert from wix:image://v1/[mediaUrl]/
};

var formatSrcToFilename = function formatSrcToFilename(src) {
  try {
    return isMediaSrc(src) ? src.split('/')[4].split('#')[0] : '_.jpg'; //convert from wix:image://v1/[mediaUrl]/
  } catch (e) {
    return '_.jpg';
  }
};

var formatImageUrlToSrc = function formatImageUrlToSrc(mediaUrl, meta) {
  return 'wix:image://v1/' + (mediaUrl || utils.slugify(meta.name)) + '/' + utils.slugify(meta.fileName || meta.name) + '#originWidth=' + meta.width + '&originHeight=' + meta.height;
};

var formatVideoUrlToSrc = function formatVideoUrlToSrc(videoUrl, meta) {
  return 'wix:video://v1/' + (videoUrl || utils.slugify(meta.name)) + '/' + utils.slugify(meta.fileName || meta.name) + '#posterUri=' + meta.posters[0].url + '&posterWidth=' + meta.width + '&posterHeight=' + meta.height;
};

var dimensionsFromUrl = function dimensionsFromUrl(url) {
  var dimensions = {};
  var foundDimensions = false;
  try {
    //dimensions from url
    var regex = /\/\d*_\d*\//;

    var match = regex.exec(url);
    if (match && match[0] && match[0].length > 0) {
      var _match$0$replace$spli = match[0].replace(/\//g, '').split('_').map(function (i) {
        return Number(i);
      }),
          _match$0$replace$spli2 = (0, _slicedToArray3.default)(_match$0$replace$spli, 2),
          originWidth = _match$0$replace$spli2[0],
          originHeight = _match$0$replace$spli2[1];

      if (originWidth > 0 && originHeight > 0) {
        foundDimensions = true;
        dimensions = {
          originWidth: originWidth,
          originHeight: originHeight
        };
      }
    }
  } catch (e) {
    dimensions = {};
    foundDimensions = false;
  }

  if (!foundDimensions) {
    /*
    Breaks a url of this format : wix:image://v1/<uri>/<filename>#originWidth=<width>&originHeight=<height>[&watermark=<watermark_manifest_string>]
    to a hash like this  {
      originWidth: <width>
      originHeight: <height>
      watermark: <watermark_manifest_string>
    }
    */
    try {
      //dimensions from hash
      url.split('#')[1].split('&').map(function (dim) {
        return dim.split('=');
      }).forEach(function (dim) {
        dimensions[dim[0]] = isNaN(Number(dim[1])) ? String(dim[1]) : Number(dim[1]);
      });
    } catch (e) {
      dimensions = {};
      foundDimensions = false;
    }
  }
  return dimensions;
};

var oldWixCodeItemToProGallery = function oldWixCodeItemToProGallery(wixCodeItem, i) {
  return {
    itemId: utils.createUniqueUuidFromString(i + '_' + (wixCodeItem.uri || wixCodeItem.alt || i)),
    mediaUrl: wixCodeItem.uri || '',
    metaData: {
      height: wixCodeItem.height || 1,
      lastModified: Date.now(),
      link: formatTextLinkToObject(wixCodeItem.link, wixCodeItem.target),
      title: wixCodeItem.title || '',
      description: wixCodeItem.description || '',
      alt: wixCodeItem.alt || '',
      sourceName: 'private',
      tags: [],
      width: wixCodeItem.width || 1
    },
    orderIndex: i
  };
};

var newWixCodeItemToProGallery = function newWixCodeItemToProGallery(wixCodeItem, i) {
  var dimensions = dimensionsFromUrl(wixCodeItem.src);
  dimensions.width = wixCodeItem.width || dimensions.originWidth || dimensions.originalWidth || dimensions.posterWidth || 1;
  dimensions.height = wixCodeItem.height || dimensions.originHeight || dimensions.originalHeight || dimensions.posterHeight || 1;
  var focalPoint = wixCodeItem.settings && wixCodeItem.settings.focalPoint;
  var type = (wixCodeItem.type || 'image').toLowerCase();
  var item = {
    itemId: utils.slugify(wixCodeItem.slug) || (utils.slugify(wixCodeItem.title || wixCodeItem.id) || utils.createUniqueUuidFromString(wixCodeItem.src || wixCodeItem.html || i)) + '_' + i,
    mediaUrl: formatSrcToMediaUrl(wixCodeItem.src),
    metaData: (0, _assign2.default)({
      type: type,
      alt: wixCodeItem.title || '',
      title: wixCodeItem.title || '',
      description: wixCodeItem.description || '',
      name: formatSrcToFilename(wixCodeItem.src),
      fileName: formatSrcToFilename(wixCodeItem.src),
      link: formatTextLinkToObject(wixCodeItem.link, wixCodeItem.target),
      width: dimensions.width,
      height: dimensions.height,
      sourceName: 'private'
    }, focalPoint ? {
      focalPoint: focalPoint
    } : {}),
    orderIndex: i
  };

  if (type === 'text') {
    var style = wixCodeItem.style;
    item.metaData.height = dimensions.height || 500;
    item.metaData.width = dimensions.width || 500 * style.layoutRatio;
    item.metaData.textStyle = {
      width: item.metaData.width,
      height: item.metaData.height,
      backgroundColor: style.fillColor
    };
    item.metaData.html = item.editorHtml = wixCodeItem.html;
  }

  if (type === 'video') {
    item.metaData.posters = [{
      url: dimensions.posterUri || wixCodeItem.thumbnail,
      width: dimensions.width,
      height: dimensions.height
    }];
    item.isExternal = wixCodeItem.src.indexOf('http') === 0;
    if (item.isExternal || isMediaSrc(wixCodeItem.src)) {
      item.metaData.source = wixCodeItem.src.indexOf('youtube.com') > 0 ? 'youtube' : wixCodeItem.src.indexOf('vimeo.com') > 0 ? 'vimeo' : 'wix';
      item.metaData.videoUrl = wixCodeItem.src;
    } else {
      item.metaData.qualities = [{
        width: dimensions.width,
        height: dimensions.height,
        quality: dimensions.height + 'p',
        formats: [isMediaSrc(wixCodeItem.src) ? 'wix' : wixCodeItem.src.split(/#|\?/)[0].split('.').pop().trim()]
      }];
    }
  }

  return item;
};

var isNewWixCodeItemFormat = function isNewWixCodeItemFormat(wixCodeItem) {
  return !!(wixCodeItem.src || wixCodeItem.type && wixCodeItem.html);
};

var wixCodeItemToProGallery = function wixCodeItemToProGallery(wixCodeItem) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  return isNewWixCodeItemFormat(wixCodeItem) ? newWixCodeItemToProGallery(wixCodeItem, i) : oldWixCodeItemToProGallery(wixCodeItem, i);
};

var wixCodeItemsToProGallery = function wixCodeItemsToProGallery(wixCodeItems) {

  var formattedItemsDto = [];
  try {
    wixCodeItems.forEach(function (wixCodeItem, i) {
      return formattedItemsDto.push(wixCodeItemToProGallery(wixCodeItem, i));
    });
    // console.log('Converted wix code items', wixCodeItems, formattedItemsDto);
  } catch (e) {
    console.error('Wrong format for gallery items', wixCodeItems, e);
  }
  return formattedItemsDto;
};

var proGalleryItemToOldWixCode = function proGalleryItemToOldWixCode(itemDto) {
  var meta = itemDto.metaData || itemDto.metadata || {};
  var link = formatObjectLinkToText(meta.link) || {};
  return (0, _extends3.default)({
    uri: itemDto.mediaUrl,
    description: meta.description,
    alt: meta.title,
    title: meta.title,
    height: meta.height,
    width: meta.width
  }, link);
};

//gallery-type editor: convert from orginaize-media to wix-code
var proGalleryItemToNewWixCode = function proGalleryItemToNewWixCode() {
  var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


  var meta = item.metaData || item.metadata || {};
  var link = formatObjectLinkToText(meta.link) || {};
  var dbItem = (0, _extends3.default)({
    type: meta.type || 'image',
    slug: item.itemId
  }, link);
  var type = dbItem.type.toLowerCase();
  if (type === 'text') {
    var style = meta.testStyle || {};
    (0, _assign2.default)(dbItem, {
      html: meta.html,
      style: {
        width: style.width,
        height: style.height,
        bgColor: style.backgroundColor
      }
    });
  } else {
    (0, _assign2.default)(dbItem, {
      title: meta.title,
      description: meta.description
    });
    if (type === 'image') {
      (0, _assign2.default)(dbItem, {
        src: formatImageUrlToSrc(item.mediaUrl, meta),
        settings: (0, _assign2.default)({}, meta.focalPoint ? {
          focalPoint: meta.focalPoint
        } : {})
      });
    } else if (type === 'video') {
      (0, _assign2.default)(dbItem, {
        src: formatVideoUrlToSrc(item.mediaUrl, meta),
        thumbnail: item.mediaUrl
      });
    }
  }
  return dbItem;
};

var proGalleryItemToWixCode = function proGalleryItemToWixCode() {
  var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var isNew = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  return isNew ? proGalleryItemToNewWixCode(item) : proGalleryItemToOldWixCode(item);
};

var proGalleryItemsToWixCode = function proGalleryItemsToWixCode(itemsDto) {
  var isNew = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var formattedItemsDto = [];
  itemsDto.forEach(function (itemDto) {
    return formattedItemsDto.push(proGalleryItemToWixCode(itemDto, isNew));
  });
  return formattedItemsDto;
};

exports.wixCodeItemToProGallery = wixCodeItemToProGallery;
exports.wixCodeItemsToProGallery = wixCodeItemsToProGallery;
exports.proGalleryItemToWixCode = proGalleryItemToWixCode;
exports.proGalleryItemsToWixCode = proGalleryItemsToWixCode;